import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, IPassengerTable } from '../../../interface/interfaces';

interface IIniitalState {
    nodeInfoLoading: boolean;
    nodeInfoData: IPassengerTable[];
    nodeInfoError: string;
}

const initialState: IIniitalState = {
    nodeInfoLoading: false,
    nodeInfoData: [],
    nodeInfoError: '',
};

const nodeInfoSlice = createSlice({
    name: 'nodeInfo',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchNodeInfoPending: (state: IIniitalState, action: PayloadAction<IDataInput>) => {
            state.nodeInfoLoading = true
            state.nodeInfoError = ''
        },

        fetchNodeInfoFulfilled: (state: IIniitalState, action: PayloadAction<IPassengerTable[]>) => {
            // console.log('SA SLICE: ', action.payload)    
            state.nodeInfoLoading = false
            state.nodeInfoData = action.payload
            state.nodeInfoError = ''
        },
        fetchNodeInfoFailure: (state: IIniitalState, action: PayloadAction<string>) => {
            state.nodeInfoLoading = false
            state.nodeInfoData = []
            state.nodeInfoError = action.payload
        },

        clearNodeInfo: (state: IIniitalState) => {
            state.nodeInfoLoading = false
            state.nodeInfoData = []
            state.nodeInfoError = ''
        }
    },
});

export default nodeInfoSlice.reducer;
export const { fetchNodeInfoPending, fetchNodeInfoFulfilled, fetchNodeInfoFailure, clearNodeInfo} = nodeInfoSlice.actions;
